import { Avatar, useTheme } from '@vitvio/design-system';
import { useUserContext } from '@vitvio/user-context';

export function UserAvatar() {
  const { username } = useUserContext();
  const { getColor, getSpacing } = useTheme();

  return (
    <Avatar
      name={username}
      bg={getColor('button.bg.primary')}
      color={getColor('fg.inverted')}
      fontWeight={'semibold'}
      size={'sm'}
      mx={'auto'}
      mb={getSpacing('3')}
    />
  );
}
